import { BiLockOpenAlt } from "react-icons/bi"; 
import { BiLockAlt } from "react-icons/bi"; 
import { BiDotsVerticalRounded } from "react-icons/bi";
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import * as FxTable from '../../fx/FxTable';
import * as FxDat from '../../fx/FxDat';
import GxList from '../../gx/GxList';
import { getStoreValueBo, clearStore, StoreStock, StoreStockLot, StorePurLst, StorePurDoc } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import { useWindowSize } from '../../hx/useWindowSize';
import CxSnackbar from '../../cx/CxSnackbar';
import CxButtonMenu from '../../cx/CxButtonMenu';
import CxCheck from '../../cx/CxCheck';
import * as MxPurDocFormH1 from './MxPurDocFormH1';


const MxStockroomLotList = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ isFullAccess }] = useAccess(trans('field.stockrooms'));
  const [{ navTo }] = useNav();

  const size = useWindowSize();

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);

  const [lockDelete, setLockDelete] = React.useState(true);
  
  const hasColumnPsCode = () => { return Boolean(localStorage.getItem('MxStockroomLotList.addcol_txPsCode')==='1')};
  const hasColumnPurInv = () => { return Boolean(localStorage.getItem('MxStockroomLotList.addcol_txPurInvoice')==='1')};
  const hasColumnPurInvDate = () => { return Boolean(localStorage.getItem('MxStockroomLotList.addcol_dtPurInvoice')==='1')};

  const r_list = React.useRef(null);

  const rf_boIncludeExpired = React.useRef(null);

  const [storeStock, ] = useSessionStorage('StoreStock', StoreStock);
  const [storeStockLot, setStoreStockLot] = useSessionStorage('StoreStockLot', StoreStockLot);
  const [storePurLst, setStorePurLst] = useSessionStorage('StorePurLst', StorePurLst);
  const [storePurDoc, setStorePurDoc] = useSessionStorage('StorePurDoc', StorePurDoc);

  const r_snack_op_successful = React.useRef(null);

  React.useEffect(() => {
    clearStore('StoreStockLot', storeStockLot);
    clearStore('StorePurLst', storePurLst);
    clearStore('StorePurDoc', storePurDoc);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {
    storeStockLot.inPs = row.original.inPs;
    storeStockLot.txPs = row.original.txPs;
    storeStockLot.txLotCode = row.original.txLotCode;
    storeStockLot.dtLotExpr = row.original.dtLotExpr;
    storeStockLot.boLotActive = row.original.boLotActive;
    Promise.all([setStoreStockLot(storeStockLot)]).then((result) => {
      navTo("stock-lot-form");
    });
  }

  const getTableColumns = () => {
    let cols = [];
    let id = -1;
    cols.push({ id: id++, Header: "ID", accessor: "inPs", show: false });
    cols.push({ id: 'inPurInvoice', Header: "_inPurInvoice", accessor: "inPurInvoice", show: false });
    if (size.isLarge) { // PANTALLA GRANDE
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '30%' });
      cols.push({ id: id++, Header: trans('field.code'), accessor: "txPsCode", highlight: true, width: '15%', show: hasColumnPsCode() });
      cols.push({ id: id++, Header: trans('field.lot'), accessor: "txLotCode", highlight: true, width: '20%' });
      cols.push({ id: id++, Header: trans('field.expiration'), accessor: "dtLotExpr", highlightDate: true, width: '20%' });
      cols.push({ id: id++, Header: trans('field.purchase_invoice_s'), accessor: "txPurInvoice", highlight: true, width: '15%', show: hasColumnPurInv() });
      cols.push({ id: id++, Header: trans('field.date'), accessor: "dtPurInvoice", highlightDate: true, width: '15%', show: hasColumnPurInvDate() });
      cols.push({ id: id++, Header: trans('field.purchases'), accessor: row => (FxTable.cellTo2r00(row["qyPur"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.sales'), accessor: row => (FxTable.cellTo2r00(row["qySls"])), width: '10%', align: 'right' });
      cols.push({ id: id++, Header: trans('field.stock_lot'), accessor: row => (FxTable.cellTo2r00(row["qyStock"])), width: '10%', align: 'right' });
      
    } else { // PANTALLA PEQUEÑA
      cols.push({ id: id++, Header: trans('field.ps'), accessor: "txPs", highlight: true, width: '70%' });
      cols.push({ id: id++, Header: trans('field.lot'), accessor: "txLotCode", highlight: true, width: '30%' });
    }

    cols.push({ id: "A", Header: "_inactive", accessor: row => row["boLotActive"] === '0', show: false });
    cols.push({ id: "W", Header: "_expired", accessor: row => Boolean(row["dtLotExpr"] && (FxDat.toIso(row["dtLotExpr"]) < FxDat.today())), show: false });
    cols.push({ id: "R", Header: "_sold_out", accessor: row => Boolean((row["qyStock"]) <= 0 ? true : false), show: false });
    
    cols.push({
      id: "BTN_DEL", icon: <BiLockAlt />, icon_alt: <BiLockOpenAlt />, iconTooltip: trans('field.column_lock_unlock'), onIconClick: () => setLockDelete(!lockDelete),
      accessor: getTableButtonMenu,
      align: 'center', width: '33px'
    });
    
    return cols;
  }

  const doDelete = (row) => {
    let record = {};
    record['inPs'] = row.inPs;
    record['txPs'] = row.txPs;
    record['txLotCodeOri'] = row.txLotCode;
    Promise.all([FxFetch.doJsonX(`stock/lots/d`, record)]).then((result) => {
      if (result[0].theValue === 'OK') {
        r_list.current.redisplay();
      }
    });
  }

  const openPurchaseInvoice = (row) => {
    FxLog.infox('MxStockroomLotList.openPurchaseInvoice', '...row:', row);
    storePurLst.listType = 'i';
    storePurLst.listTypeBackground = 'var(--ibs_color_blue_light)';
    storePurLst.table = 'n_pur_invoice';
    storePurLst.table_idField = 'inPurInvoice';
    storePurLst.table_txField = 'txPurInvoice';
    storePurLst.table_dtField = 'dtPurInvoice';
    storePurLst.table_item = 'n_pur_invoice_item';
    storePurLst.table_item_idField = 'inPurInvoiceItem';
    storePurLst.table_paym_idField = 'inPurPayment';
    Promise.all([setStorePurLst(storePurLst)]).then((result) => {
      storePurDoc.boFirstRender = true;
      storePurDoc.boDataChanged = '0';
      storePurDoc.docType = 'i';
      storePurDoc.inPurXXX = row.inPurInvoice;
      Promise.all([MxPurDocFormH1.load(storePurLst, storePurDoc)]).then((result) => {
        setStorePurDoc(storePurDoc);
        navTo("pur-doc-form");
      });
    });
  }

  const doLineOptions = (option, row) => {
    if (option === 'delete') {
      doDelete(row);
    }
    if (option === 'open-pur-invoice') {
      openPurchaseInvoice(row);
    }
  }

  const getTableButtonMenu = (row) => (
    <CxButtonMenu
      row={row}
      onSelection={doLineOptions}
      className='ibs_iconbutton_table_body'
      icon={<BiDotsVerticalRounded />}
      options={[
        { id: 'delete', text: trans('field.delete') },
        { id: 'open-pur-invoice', text: trans('field.open_x', 'field.invoice') },
      ]}
      disabled={lockDelete}
    />
  );

  const getTableOptionalCols = () => {
    let cols = [];
    cols.push({id: 'txPsCode', name: trans('field.code') + " +🔍︎", checked: hasColumnPsCode() ? '1' : '0'}); 
    cols.push({id: 'txPurInvoice', name: trans('field.purchase_invoice_s') + " +🔍︎", checked: hasColumnPurInv() ? '1' : '0'}); 
    cols.push({id: 'dtPurInvoice', name: trans('field.date') + " +🔍︎", checked: hasColumnPurInvDate() ? '1' : '0'}); 
    return cols;
  }

  const optionsSelected = (options) => {
    localStorage.setItem('MxStockroomLotList.addcol_txPsCode', options.includes('txPsCode') ? '1' : '0');
    localStorage.setItem('MxStockroomLotList.addcol_txPurInvoice', options.includes('txPurInvoice') ? '1' : '0');
    localStorage.setItem('MxStockroomLotList.addcol_dtPurInvoice', options.includes('dtPurInvoice') ? '1' : '0');
    r_list.current.getTable().setTooltipText(getTooltip());
    r_list.current.getTable().clearSearch();
    forceUIUpdate();
  }

  const getTooltip = () => {
    let tip = `${trans('field.ps')}`;
    tip = tip + `${' / ' + trans('field.lot')}`;
    if (size.isLarge) {
      tip = tip + `${' / ' + trans('field.expiration')}`;
      if (hasColumnPsCode()) tip = tip + `${' / ' + trans('field.code')}`;
      if (hasColumnPurInv()) tip = tip + `${' / ' + trans('field.purchase_invoice_s')}`;
      if (hasColumnPurInvDate()) tip = tip + `${' / ' + trans('field.date')}`;
    }
    
    return tip;
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.stockroom')}: ${trans('field.lots')}: ${getStoreValueBo('StoreSession', 'boSingleStockLot') ? trans('field.all_branches') : storeStock.txBranchId}`}
        xref={r_list}
        id="MxStockroomLotList"
        tooltip={getTooltip()}
        fullscreen
        url="stock/lots"
        addParams={`inBranch=${storeStock.inBranch}`}
        filter={`n_pur_invoice_item.dtLotExpr>date(now())`}
        onOpenForm={openForm}
        refColors={[ 
          'table_cell_color_gray|' + trans('field.inactive'),
          'table_cell_color_brown|' + trans('field.expired'), 
          'table_cell_color_red|' + trans('field.sold_out') 
        ]}
        hasButtonAdd={false}
        columns={getTableColumns()}
        optionalColumns={getTableOptionalCols()}
        optionalSorting={[
          { id: 'txPs', type: trans('field.ps') },
          { id: 'dtLotExpr asc', type: `${trans('field.expiration')} (${trans('field.order_asc')})` },
          { id: 'dtLotExpr desc', type: `${trans('field.expiration')} (${trans('field.order_desc')})` },
        ]}
        onOptions={optionsSelected}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
          </div>
        }
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginBottom: '5px' }}>
          <CxCheck xref={rf_boIncludeExpired} 
            label={trans('field.include_x', 'field.expired_p').toUpperCase()} 
            defaultChecked={false} 
            //width={150}
            fontSize={10}
            onClick={(boIncludeExpired) => {
              FxLog.infox('MxStockroomLotList.onClick', '...boIncludesExpired:', boIncludeExpired);
              if (boIncludeExpired) {
                FxLog.infox('MxStockroomLotList.onClick', '...ALL lots!');
                r_list.current.setdeepFilter('');
              } else {
                FxLog.infox('MxStockroomLotList.onClick', '...only active lots!');
                r_list.current.setdeepFilter(`n_pur_invoice_item.dtLotExpr>date(now())`);
              }
              
              setTimeout(() => r_list.current.redisplay(), 100); // Retrasa el redisplay para dejar que el checkbox se pinte
            }}
          />
        </div>

      </GxList>

      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />

    </div>
  );

}

export default MxStockroomLotList;
